import styled from 'styled-components';
import { Icon } from '../icon/icon.component.js';

const getIconColor = (props) => {
    if (props.type === 'CTA') {
        if (props.backgroundless) {
            return props.color === 'primaryInverse' ? 'primaryInverse' : 'primary';
        }
        else {
            return props.theme.colors.maps.backgroundToContent[props.backgroundColor];
        }
    }
    else {
        return props.color;
    }
};
const LinkIcon = styled(Icon).attrs(props => ({
    color: getIconColor(props),
    margin: { left: '4px' },
})) `
  transition: transform ${props => props.theme.transitionDurations.default};
`;

export { LinkIcon };
